// extracted by mini-css-extract-plugin
export default {"report-name":"ReportName_report-name__hwJRG"};